import { styled } from '@linaria/react';
import { breakpoints, fonts, primitives, radius, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 ${space['space-600']};
`;

export const Title = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const NavControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-0']};
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${primitives.size['size-1000']};
  padding: ${space['space-100']} ${space['space-400']};
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${semantic.text.primary};
  box-sizing: border-box;
  border-radius: ${radius('button', 'radius-full')};
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const ChipsRow = styled.div`
  display: flex;
  width: 100%;
  gap: ${space['space-200']};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  border-radius: ${radius('chip', 'radius-sm')};

  &::-webkit-scrollbar {
    display: none;
  }

  &[data-wrap],
  &[data-layout='fill'] {
    overflow-x: visible;
  }

  &[data-wrap] {
    flex-wrap: wrap;
  }

  &[data-layout='grid'] {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    overflow-x: visible;

    @media (min-width: ${breakpoints.desktop}) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }

  &[aria-invalid='true'] {
    box-shadow: inset 0 0 0 ${size.stroke['stroke-default']} ${semantic.border.danger};
  }
`;

export const Chip = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: ${primitives.size['size-2000']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  background: transparent;
  cursor: pointer;
  padding: ${space['space-300']} ${space['space-500']};
  font-family: ${fonts.body};
  border-radius: ${radius('chip', 'radius-sm')};
  box-sizing: border-box;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  flex-shrink: 0;
  gap: ${space['space-0']};

  [data-layout='fill'] > & {
    flex: 1 1 0;
    min-width: 0;
  }

  [data-layout='grid'] > & {
    min-width: 0;
  }

  &[data-selected] {
    background: ${semantic.bg.brand};
    color: ${semantic.text.inverse};
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  &:hover:not([data-selected]):not(:disabled) {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const ChipTime = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${(p) => (p.$selected ? semantic.text.inverse : semantic.text.primary)};
`;

export const ChipSublabel = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xs};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${(p) => (p.$selected ? semantic.text.inverse : semantic.text.primary)};
  white-space: nowrap;
`;

export const ChipDetail = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.sm};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${(p) => (p.$selected ? semantic.text.inverse : semantic.text.secondary)};
  white-space: nowrap;
`;

export const ChipPrice = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xs};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${(p) => (p.$selected ? semantic.text.inverse : semantic.text.primary)};
  white-space: nowrap;
`;

export const ErrorRow = styled.div`
  margin-top: ${space['space-200']};
`;
